








import {defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "HeadingAtom",
    props: {
        size: {
            type: Number,
            default: 3
        },
        dynamicColor: {
            type: Boolean,
            default: true
        }
    }
})
